export default __webpack_public_path__ + "static/media/video-screenshot.02e311dc.png";